import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const crearOeditarHoraExtra = async (data) => {
    const headers = getHeaders();

    try {
        if (data.id != "") {
            const resp = await axios.post(
                `${API_URL}/turnos/horasExtras/${data.id}`,
                data,
                { headers: headers }
            );

            return resp;
        }

        const resp = await axios.post(`${API_URL}/turnos/horasExtras`, data, {
            headers: headers,
        });

        return resp;
    } catch (error) {
        return processError(error);
    }
};

export const eliminarHorasExtras = async (id) => {
    try {
        const resp = await axios.delete(`${API_URL}/turnos/horasExtras/${id}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerHoraExtra = async (fecha, personaId) => {
    const data = { fecha, persona_id: personaId };

    try {
        const resp = await axios.post(
            `${API_URL}/turnos/horasExtras/consultar`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerHoraExtraGuardada = async () => {
    try {
        const resp = await axios.get(
            `${API_URL}/turnos/horasExtras/guardadas`,
            { headers: getHeaders() }
        );
        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerHoraExtraAceptadasPorGerencia = () => {
    return axios.get(`${API_URL}/turnos/horasExtras/financiera`, {
        headers: getHeaders(),
    });
};

export const enviarHoraExtraGerencia = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/turnos/horasExtras/enviar`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const pagarHoraExtra = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/turnos/horasExtras/pagar`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectEmpleadosConReglasOSecuenciasAreaSedeId = async (data) => {
    try {
        const resp = await axios.post(
            `${API_URL}/empleados/select/conReglasAreaSedeId`,
            data,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
